module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "box1"
  }, [_c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _vm._v("COPING")]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "h2a"
  }, [_vm._v("Kimberly")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Moses’ father-in-law replied, “What you are doing is not good. You and these people who come to you will only wear yourselves out. The work is too heavy for you; you cannot handle it alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "centers"
  }, [_vm._v("EXODUS 18:17–18")]), _vm._v(" "), _c('p', {
    staticClass: "normal3"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_c('span', {
    staticClass: "co"
  }, [_vm._v("I")])]), _vm._v(" wasn’t even sure how it happened. But the truth glared up at me from my bathroom scale. I had gained one hundred pounds in the first year of my daughter’s life. Instead of turning to God to help me deal with the strain of serving a child with multiple disabilities, I had turned to sleep and food.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("We all find ways to cope. Unfortunately, not every method is healthy. Gillian Marchenko turned to alcohol after her baby was born with Down syndrome. “It wasn’t long before I was drinking a bottle of wine at night. It helped me sleep.” She found herself wanting alcohol even earlier in the day, and even describes being hung over at an 11:00 a.m. church service. “While fighting the urge to puke, I bowed my head during prayer like everyone else. But I could not pray, because my head was still spinning. "), _c('i', [_vm._v("Oh my gosh! Am I drunk in church?")]), _vm._v("”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#fn10",
      "id": "rfn10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" It was a turning point for Gillian, after which she deliberately turned to healthier ways to cope.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v("Jeff Davidson, whose son has autism and cerebral palsy, coped by accumulating possessions. “I put in a pool, bought a hot tub, drove the nicest SUVs, and remodeled our house. I traded cars every year and a half, and I tried to spend us out of the pain. I hit rock bottom when I converted half our basement into a man cave. . . . One night [I realized what I’d done]. Going down into the basement meant going down fifteen narrow steps to get there. My son, with his cerebral palsy, would never be able to come down there. Jon Alex would never be able to join me in my man cave. I realized I had built a monument to my own selfishness, greed, and needs.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#fn11",
      "id": "rfn11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Did any of us intentionally decide to adopt a harmful habit? No. The danger lies in the fact that we don’t have to. At every turn, the world will offer us coping mechanisms to deal with our pain. It is far easier to slip into any of them than it is to resist. We must realize, however, that what we need is more of Christ in our lives, in our days, in our messy moments. We don’t need more alcohol, or more ice cream, or more shoes, or more technology. Those things won’t heal us. Christ will. “The one who is in you is greater than the one who is in the world” (1 John 4:4).")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("In addition to turning to Christ to overcome, we can also look for help from an accountability partner or support group. In Exodus 18, Moses found himself becoming worn out from judging the disputes brought before him from morning until evening. Wisely, his father-in-law told him in verse 22 to share the burden with others in order to make the load lighter. Ecclesiastes 4 tells us that two are better than one (v. 9), and a cord of three strands is not quickly broken (v. 12).")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("When we turn to Christ and to Christian supporters, we find the strength to fight the battle of our unhealthy coping mechanisms. Over the last fourteen years, the Lord has worked in my heart to heal my grief in stages, and he continues to transform my mind to be more like his. The work he has done in my spirit has translated to a sixty-pound weight loss on my body. I still struggle with food and the desire to sleep "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v("instead of dealing with the issues at hand, but I am encouraged that he who began a good work in me will be faithful to complete it (Phil. 1:6).")]), _vm._v(" "), _c('div', {
    staticClass: "top1"
  }, [_c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Dear Lord, you are mercy and forgiveness. Help me turn from harmful habits and look to you instead. Give me the strength to reach out to others for help. In Jesus’s name, amen.")])])]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGGING")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EEPER")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("1."), _c('span', {
    staticClass: "space5"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Are there any unhealthy coping mechanisms that you are currently using to deal with your pain? If so, what are they?")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("2."), _c('span', {
    staticClass: "space5"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("What can you do to no longer turn to things rather than to Christ for healing and comfort?")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("3."), _c('span', {
    staticClass: "space5"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("With whom can you share your story for accountability and prayer?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-838c00f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Chapter06.vue
// module id = 99
// module chunks = 0